var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip:hover",arg:"hover"}],attrs:{"variant":"warning","title":_vm.title,"data-cy":"premium-feature"}},[_vm._v(" Premium Feature ")])}
var staticRenderFns = []

export { render, staticRenderFns }